import React from 'react'
import Menu from '@/components/ui/Menu'
import { ReactComponent as SecretIcon } from '@/assets/icons/secret.svg'
import { StudioSecret } from '@/lib/react-query'
import Button from '@/components/ui/Buttons/Button'
import Typography from '@/components/ui/Typography'
import { Dropdown } from '@mui/base/Dropdown'
import { HeaderTrigger } from '@/components/ui/Menu/Trigger'
import { useQuery } from '@tanstack/react-query'
import { secretsQueries } from '@/features/secrets'

export type SecretsMenuProps = {
  projectId: number
  onSelect: (secret: StudioSecret) => void
  onNewSelect: () => void
}
export const SecretsMenu = ({ projectId, onSelect, onNewSelect }: SecretsMenuProps) => {
  const query = useQuery(secretsQueries.list(projectId))

  return (
    <Dropdown>
      <HeaderTrigger StartIcon={<SecretIcon />}>Secrets</HeaderTrigger>
      <Menu>
        <Menu.Body>
          {query.isLoading ? (
            <Typography>Loading</Typography>
          ) : (
            query.data?.map((secret) => (
              <Menu.Item key={secret.id} StartIcon={<SecretIcon />} onClick={() => onSelect(secret)}>
                {secret.name}
              </Menu.Item>
            ))
          )}
        </Menu.Body>
        <Menu.Footer>
          <Button color={'neutral'} variant={'outlined'} isStretched onClick={onNewSelect}>
            + Add new
          </Button>
        </Menu.Footer>
      </Menu>
    </Dropdown>
  )
}
